/**
 * A lista lateral do modo Otto (docs/specs/otto/TDD.md §4 e §6): o Otto ativo no alto, os módulos que o plano não tem com
 * CADEADO (cada um um link real para o endereço do módulo, onde a vitrine aparece) e, para o administrador, Usuários.
 *
 * É uma lista nova, e não um `if (modoOtto)` espalhado pela lista da plataforma: o `InternalLayout` só escolhe qual desenhar.
 * Módulo que o plano tem aparece como item normal (sem cadeado), no seu endereço de sempre.
 *
 * @param {{
 *   ottoPath: string,
 *   isOttoActive: boolean,
 *   modules: { key: string, label: string, icon: import('react').ElementType, to: string, active: boolean, locked: boolean }[],
 *   adminItems?: { key: string, label: string, icon: import('react').ElementType, to: string, active: boolean }[],
 * }} props
 */
import { OttoIcon } from '@/features/otto/brand/OttoIcon';
import { SidebarItem } from '@/components/internal/Sidebar';

export default function OttoSidebarNav({ ottoPath, isOttoActive, modules, adminItems = [] }) {
    return (
        <>
            <SidebarItem navKey="otto" icon={OttoIcon} label="Otto" to={ottoPath} active={isOttoActive} className="mb-1" />

            {modules.length > 0 && <div className="my-3 mx-2 border-t border-border/50" />}
            {modules.map((module) => (
                <SidebarItem
                    key={module.key}
                    navKey={module.key}
                    icon={module.icon}
                    label={module.label}
                    to={module.to}
                    active={module.active}
                    locked={module.locked}
                    hint={module.locked ? `${module.label} não está incluso no seu plano. Abra para conhecer.` : undefined}
                    className="mb-1"
                />
            ))}

            {adminItems.length > 0 && <div className="my-3 mx-2 border-t border-border/50" />}
            {adminItems.map((item) => (
                <SidebarItem
                    key={item.key}
                    navKey={item.key}
                    icon={item.icon}
                    label={item.label}
                    to={item.to}
                    active={item.active}
                    className="mb-1"
                />
            ))}
        </>
    );
}
